// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentMethodForm-paymentSectionWrapper-Aoaug {
    padding: 24px;
    border-radius: var(--radius-3);
    background-color: var(--background-primary);
}

.PaymentMethodForm-sectionTitle-iDteY {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    color: var(--primary-foreground);
    margin-bottom: 18px;
    text-align: start;
}

.PaymentMethodForm-paymentCardSection-ttp0n {
    background-color: var(--background-secondary);
    padding: 18px;
    border-radius: var(--radius-3);
}

.PaymentMethodForm-labelFlex-tzpzb {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 6px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
}

.PaymentMethodForm-cardLabel-ipGPU {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 10px;
    color: var(--primary-foreground);
}

.PaymentMethodForm-cardMiddleLine-pfNIJ {
    border-bottom: 1px solid var(--primary-border);
    padding-bottom: 12px;
}

.PaymentMethodForm-cardNumberShow-pcquS {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    color: var(--primary-foreground);
}

.PaymentMethodForm-editDeleteRow-JUOro {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
}

.PaymentMethodForm-cardEditDeleteBtn-Jpov0 {
    display: inline-block;
    cursor: pointer;
    color: var(--primary-foreground);
}

.PaymentMethodForm-cardEditDeleteBtn-Jpov0:hover,
.PaymentMethodForm-cardEditDeleteBtn-Jpov0:focus {
    color: var(--primary-foreground);
}

.PaymentMethodForm-paymentCardBox-dJrJu {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    grid-gap: 24px;
}

.PaymentMethodForm-paymentPlatformIcon-C2esc {
    width: 24px;
    height: 24px;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

@media (max-width: 767px) {

    .PaymentMethodForm-paymentCardBox-dJrJu {
        grid-template-columns: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PaymentMethodForm/PaymentMethodForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,6CAA6C;IAC7C,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,8CAA8C;IAC9C,oBAAoB;AACxB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gCAAgC;AACpC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAc;QAAd,cAAc;AAClB;;AAEA;;IAEI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".paymentSectionWrapper {\n    padding: 24px;\n    border-radius: var(--radius-3);\n    background-color: var(--background-primary);\n}\n\n.sectionTitle {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 30px;\n    color: var(--primary-foreground);\n    margin-bottom: 18px;\n    text-align: start;\n}\n\n.paymentCardSection {\n    background-color: var(--background-secondary);\n    padding: 18px;\n    border-radius: var(--radius-3);\n}\n\n.labelFlex {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 600;\n}\n\n.cardLabel {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    color: var(--primary-foreground);\n}\n\n.cardMiddleLine {\n    border-bottom: 1px solid var(--primary-border);\n    padding-bottom: 12px;\n}\n\n.cardNumberShow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    color: var(--primary-foreground);\n}\n\n.editDeleteRow {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.cardEditDeleteBtn {\n    display: inline-block;\n    cursor: pointer;\n    color: var(--primary-foreground);\n}\n\n.cardEditDeleteBtn:hover,\n.cardEditDeleteBtn:focus {\n    color: var(--primary-foreground);\n}\n\n.paymentCardBox {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n    grid-gap: 24px;\n}\n\n.paymentPlatformIcon {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n}\n\n@media (max-width: 767px) {\n\n    .paymentCardBox {\n        grid-template-columns: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentSectionWrapper": `PaymentMethodForm-paymentSectionWrapper-Aoaug`,
	"sectionTitle": `PaymentMethodForm-sectionTitle-iDteY`,
	"paymentCardSection": `PaymentMethodForm-paymentCardSection-ttp0n`,
	"labelFlex": `PaymentMethodForm-labelFlex-tzpzb`,
	"cardLabel": `PaymentMethodForm-cardLabel-ipGPU`,
	"cardMiddleLine": `PaymentMethodForm-cardMiddleLine-pfNIJ`,
	"cardNumberShow": `PaymentMethodForm-cardNumberShow-pcquS`,
	"editDeleteRow": `PaymentMethodForm-editDeleteRow-JUOro`,
	"cardEditDeleteBtn": `PaymentMethodForm-cardEditDeleteBtn-Jpov0`,
	"paymentCardBox": `PaymentMethodForm-paymentCardBox-dJrJu`,
	"paymentPlatformIcon": `PaymentMethodForm-paymentPlatformIcon-C2esc`
};
module.exports = ___CSS_LOADER_EXPORT___;
